import React, { useState } from 'react';

import axios from 'axios';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';

import { destroyCredentials } from '../../../../Actions/userSessionActions';
import { InLineLoading } from '../../Loading_Icon';

import { MenuItem, MenuItemIcon } from './MenuItem';
import { Divider } from './MenuDivider';

export const UserAvatarMenu = ({ userSession, closeDropdown, dispatch, history, match }) => {
    const [loadingLogOut, setLoadingLogOut] = useState(false);

    const {
        has_admin_access: hasAdminAccess = false,
        is_iae_sh: isIaeSh = false
    } = userSession.user;

	const sendStakeholderReport = () => {
        closeDropdown();

        axios.get('/ajax/reports/emailshreport').then((response) => {
			showStatusMsg(response?.data.message, 'success');
		}).catch(function(error) {
			showStatusMsg("Error sending reports");
			console.error('error: ', JSON.stringify(error.response?.data));
		});
    }

	const sendBiweeklyVCReport = () => {
        closeDropdown();

        axios.get('/ajax/biweeklybookings').then((response) => {
			showStatusMsg(response?.data.message, 'success');
		}).catch(function(error) {
			showStatusMsg('Error sending reports');
			console.error('error: ', JSON.stringify(error.response?.data));
		})
    }

	const sendEmails = () => {
        const email = prompt('Please enter the email you want to receive the emails on', '@integratedauto.com');

        axios.post('/ajax/emails/sendemails', { email }).then((response) => {
			showStatusMsg('Emails queued', 'success');
		}).catch(function(error) {
			showStatusMsg('Error sending emails');
			console.error('error: ', JSON.stringify(error.response?.data));
		});
    }

    const handleLogout = async () => {
        setLoadingLogOut(true);

        try {
            await axios.get('/ajax/logout&redirect');
        } catch (error) {
            console.error('error: ', error);
        }

        dispatch(destroyCredentials());
        localStorage.clear();
        // window.location.reload();
        history.push('/login');
        setLoadingLogOut(false);
    }

    return (
        <ul className="vertical menu">
			<MenuItemIcon linkTo="/settings" iconName="Settings" size={22}><Trans>Account Settings</Trans></MenuItemIcon>

            {hasAdminAccess && (
                <MenuItemIcon linkTo="/administration" iconName="Team" size={18}><Trans>User Administration</Trans></MenuItemIcon>
            )}

            <MenuItemIcon linkTo="/contactus" iconName="Email" size={22}><Trans>Contact Us</Trans></MenuItemIcon>

            <Divider />

            <MenuItem><Link to={`${match.url}/feedback`} className="no-padding"><Trans>Feedback</Trans></Link></MenuItem>
            <MenuItem><Link to={`${match.url}/release-notes`} className="no-padding"><Trans>Release Notes</Trans></Link></MenuItem>
            <MenuItem><Link to="/help" className="no-padding"><Trans>FAQ</Trans></Link></MenuItem>
            {/* <MenuItem><Link to="/privacy" className="no-padding"><Trans>Privacy Policy</Trans></Link></MenuItem> */}

            {isIaeSh && (
                <>
                    <Divider sectionTitle="Power User Settings" />

                    <MenuItem><Link to="/businessrules" className="no-padding"><Trans>DVMS Business Rules</Trans></Link></MenuItem>
                    <MenuItem><a className="no-padding" onClick={sendStakeholderReport}><Trans>Email Weekly Report</Trans></a></MenuItem>
                    <MenuItem><a className="no-padding" onClick={sendBiweeklyVCReport}><Trans>Email VC Report</Trans></a></MenuItem>
                    <MenuItem><a className="no-padding" onClick={sendEmails}><Trans>Send All Emails</Trans></a></MenuItem>
                </>
            )}

            <Divider />

            {loadingLogOut ? (
                <div style={{ margin: '5px auto', height: '25px' }}><InLineLoading /></div>
            ) : (
                <MenuItemIcon iconName="Logout" size={20} onClick={handleLogout}><Trans>Log Out</Trans></MenuItemIcon>
            )}
        </ul>
    )
};